<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="30%" append-to-body :before-close="resetForm">
    <el-form :model="form" :rules="rules" ref="form" label-width="80px">
      <el-form-item label="舞种" prop="name">
        <el-input v-model="form.name" placeholder="请输入舞种"></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input v-model="form.sort" type="number" placeholder="请输入排序"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="resetForm">取 消</el-button>
      <el-button type="primary" @click="confirmHandle">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import DanceService from '@/services/activity/dance';
export default {
  data () {
    const nameCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入舞种名称'));
      } else if (String(value).length > 20) {
        callback(new Error('最多20个字符'));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      title: '',
      form: {
        name: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入舞种', trigger: 'blur' },
          { required: true, validator: nameCheck, trigger: 'blur' },
        ],
        sort: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ],
      },
      isEdit: false,
      currentRowId: 0,
    }
  },
  methods: {
    openModal (rowData = {}) {
      if (Object.keys(rowData).length) {
        this.title = '编辑舞种';
        this.form = {
          name: rowData.name,
          sort: rowData.sort,
        }
        this.isEdit = true;
        this.currentRowId = rowData.id;
      } else {
        this.isEdit = false;
        this.title = '新增舞种';
        this.form = {
          name: '',
          sort: '',
        }
      }
      this.dialogVisible = true;
    },
    confirmHandle () {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const postData = {
            ...this.form,
          };
          postData.sort = Number(postData.sort)
          if (this.isEdit) {
            const { code, message } = await DanceService.updateDanceApi(this.currentRowId, postData)
            if (Object.is(code, 0)) {
              this.$message.success(message);
              this.$emit('loadData');
              this.resetForm();
            } else {
              this.$message.error(message);
            }
          } else {
            const { code, message } = await DanceService.createDanceApi(postData);
            if (Object.is(code, 0)) {
              this.$message.success(message);
              this.$emit('loadData');
              this.resetForm();
            } else {
              this.$message.error(message);
            }
          }
        } else {
          return false;
        }
      })
    },
    resetForm () {
      this.$refs.form.resetFields();
      this.dialogVisible = false;
    }
  },
}
</script>

<style lang="scss" scoped>
</style>